import React from "react";
import Select from "react-select";
import { reactSelectStyles } from "Common/Custom/ReactSelectStyles";

const RoleSelect = ({ roles = [], selectedRole, onChange }) => {
  const options = roles.map((r) => ({
    value: r.role_id,
    label: r.role_name,
  }));

  const selectedOption =
    options.find((opt) => opt.value === selectedRole) || null;

  const handleSelectChange = (selectedOption) => {
    const event = { target: { value: selectedOption ? selectedOption.value : "" } };
    onChange(event);
  };

  return (
    <div className="row mb-3 align-items-center justify-content-end">
      <div className="col-md-6">
        <Select
          options={options}
          value={selectedOption}
          onChange={handleSelectChange}
          isClearable
          placeholder="Select Role"
          styles={reactSelectStyles}
          classNamePrefix="react-select"
        />
      </div>
    </div>
  );
};

export default RoleSelect;
